import React from 'react';
import EmptyTeamScores from './emptyTeamScores';
export default function EmptyMatchScores({ blockName, }){
  const listItemBlockName = `${ blockName } ${ blockName }__list-item`;
  return (
    <li className={ listItemBlockName }>
      <EmptyTeamScores isHome={ true } blockName={ blockName }/>
      <EmptyTeamScores isHome={ false } blockName={ blockName }/>
    </li>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/emptyMatchScores.js